/**
 * 指定した期間内かどうかのチェック
 */

import { SelectDateValue } from "@interfaces/ui/form";
import { selectDateValueToDate } from "@utils/date";
import future from "@validator/rules/future";

export const dateRangeWithInDateRange = (
  baseStartDate: SelectDateValue,
  baseEndDate: SelectDateValue,
  targetStartDate: SelectDateValue,
  targetEndDate: SelectDateValue,
  message: string
): {
  year: string | undefined;
  month: undefined;
  day: undefined;
} => {
  let errorMessage;
  if (
    targetStartDate.year &&
    targetStartDate.month &&
    targetStartDate.day &&
    targetEndDate.year &&
    targetEndDate.month &&
    targetEndDate.day &&
    !future(targetEndDate, targetStartDate).year // 日付が逆転してる場合は判定しない
  ) {
    if (
      !selectDateValueToDate(baseStartDate) ||
      !selectDateValueToDate(baseEndDate)
    ) {
      errorMessage = message;
    } else {
      const baseStart = new Date(
        selectDateValueToDate(baseStartDate).replace(/-/g, "/")
      );
      const baseEnd = new Date(
        selectDateValueToDate(baseEndDate).replace(/-/g, "/")
      );
      const targetStart = new Date(
        selectDateValueToDate(targetStartDate).replace(/-/g, "/")
      );
      const targetEnd = new Date(
        selectDateValueToDate(targetEndDate).replace(/-/g, "/")
      );
      if (
        targetStart.getTime() < baseStart.getTime() ||
        targetEnd.getTime() > baseEnd.getTime()
      ) {
        errorMessage = message;
      }
    }
  }
  return {
    year: errorMessage,
    month: undefined,
    day: undefined
  };
};
